const observer = new MutationObserver(() => {
  const container = document.querySelector('.g-container');
  if (container) {
    const footer = container.querySelector('.classic-button.wizard__submit');
    if (footer) {
      observer.disconnect();

      footer.addEventListener('click', () => {
        const successMessage = document.querySelector(".message.success");

        if (successMessage) {
          successMessage.style.position = 'absolute';
          successMessage.style.opacity = '0';
          const checkDisplay = setInterval(() => {
            const display = successMessage.style.display;
            if (display === "block") {
              clearInterval(checkDisplay);
              localStorage.setItem("formStatus", "success");
              setTimeout(() => {
                history.back();
              }, 500);
            }
          }, 300);
        }
      });
    }
  }
});


observer.observe(document.body, {
  childList: true,
  subtree: true
});
